export const APP_NAME = 'Viewcastle'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const REDIRECT_TOKEN_KEY = 'token'
